module.exports = __webpack_public_path__ + "static/media/product8.82ba0041.jpg";